var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRadioActive = function SvgIconRadioActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.333A8.333 8.333 0 1 1 9 .667a8.333 8.333 0 0 1 0 16.666m-.832-5 5.893-5.892-1.179-1.179-4.714 4.714L5.811 7.62 4.633 8.798z"
  })));
};
export default SvgIconRadioActive;